import firebase from 'firebase';
import 'firebase/messaging'

const firebaseService = {
  firebase: {},
  messaging: {},
  init: function () {
    const config = {
      apiKey: 'AIzaSyCvl3gOO0UDFtpTF4SKSkbuDHmcqGwqf0M',
      authDomain: 'crwdtest.firebaseapp.com',
      databaseURL: 'https://crwdtest.firebaseio.com',
      projectId: 'crwdtest',
      storageBucket: 'crwdtest.appspot.com',
      messagingSenderId: '156514479742',
      appId: '1:156514479742:web:807d56d5d35356f83a322f',
    };
    this.firebase = firebase.initializeApp(config);

    if (firebase.messaging.isSupported()) {
      this.messaging = this.firebase.messaging();

      this.messaging
        .requestPermission()
        .then(() => {
          console.log('Have Permission');
          return this.messaging.getToken();
        })
        .then(token => {
          console.log('FCM Token:', token);
          //Do something with TOken like subscribe to topics
        })
        .catch(error => {
          if (error.code === 'messaging/permission-blocked') {
            console.log('Please Unblock Notification Request Manually');
          } else {
            console.log('Error Occurred', error);
          }
        });
    }
  },
};
export default firebaseService;
